/**
 * Üzenetmegjelenítő komponens
 * @author Erik Banhalmi 2017.06.28.
 */

export const notificationComponent = {
	bindings: {
		error: '<',
		notification: '<'
	},
	templateUrl: 'notification.html',
	controller: class notificationComponent {
		constructor($rootScope, $cookies) {
			'ngInject';
			this.$rootScope = $rootScope;
			this.$cookies = $cookies;
		}

		$onInit() {
			if (window.userInfo) {
				this.userInfo = window.userInfo;
				this.firstName = this.getFirstName();
			}
			if (this.$cookies.get('hello')) {
				if (this.$cookies.get('seenHello')) {
					this.closeHello();
				} else {
					this.$cookies.put('seenHello', true);
					this.showHello = true;
				}
			}
		}

		getFirstName() {
			if (this.userInfo.name) {
				return this.userInfo.name
					.split(' ')
					.splice(1, 1)
					.join();
			} else {
				return '';
			}
		}

		closeHello() {
			this.$cookies.remove('hello');
			this.$cookies.remove('seenHello');
			this.showHello = false;
		}
	}
};
